import {
    IInsurance,
    IInsuranceApiState,
    IProvider,
    ICreateProviderPayload,
    IPlan,
    ICreatePlanPayload,
    IBeneficiary,
    ICreateBeneficiaryPayload,
} from '../types/Insurance.types';

export const PROVIDER_INITIAL_DATA: IProvider = {
    id: 0,
    providerName: '',
    address: '',
    phoneNo: '',
    email: '',
    wellbodiWalletId: '',
    userId: '',
    createdBy: '',
    createdDate: '',
    updatedBy: null,
    updatedDate: null,
    isDelete: false,
    insuranceServiceProviders: null,
};

export const CREATE_PROVIDER_INITIAL_DATA: ICreateProviderPayload = {
    id: 0,
    providerName: '',
    address: '',
    mobileCode: 232,
    phoneNo: '',
    email: '',
    wellbodiWalletId: '',
    roleId: '',
    facilities: [],
    createdBy: '',
};

export const INSURANCE_INITIAL_DATA: IInsurance = {
    id: 0,
    patientName: '',
    facilityName: '',
    insuranceType: '',
    policyNumber: '',
    providerName: '',
    coverageAmount: '',
    createdDate: '',
    updatedDate: null,
    createdBy: '',
    updatedBy: null,
    isDelete: false,
    status: '',
    facilityId: 0,
    patientId: 0,
    age: '',
    gender: '',
    emr: '',
};

export const PLAN_INITIAL_DATA: IPlan = {
    id: 0,
    planName: '',
    insuranceProviderId: 0,
    benefitLimit: '',
    benefitAmount: 0,
    benefitSplit: '',
    outpatientRatio: 0,
    inpatientRatio: 0,
    dependentsLimit: 0,
    createdBy: '',
    createdDate: '',
    updatedBy: null,
    updatedDate: null,
    isDelete: false,
};

export const CREATE_PLAN_INITIAL_DATA: ICreatePlanPayload = {
    id: 0,
    planName: '',
    insuranceProviderId: 0,
    benefitLimit: '',
    benefitAmount: 0,
    benefitSplit: '',
    outpatientRatio: 0,
    inpatientRatio: 0,
    dependentsLimit: 0,
    createdBy: '',
    updatedBy: '',
};

export const BENEFICIARY_INITIAL_DATA: IBeneficiary = {
    id: 0,
    insurancePlanId: 0,
    primaryBeneficiaryName: '',
    primaryBeneficiaryEMRNo: '',
    dependentName: '',
    dependentRelationship: '',
    dependentEMRNo: '',
    createdBy: '',
    createdDate: '',
    updatedBy: null,
    updatedDate: null,
    isDelete: false,
};

export const CREATE_BENEFICIARY_INITIAL_DATA: ICreateBeneficiaryPayload = {
    id: 0,
    insurancePlanId: 0,
    primaryBeneficiaryName: '',
    primaryBeneficiaryEMRNo: '',
    dependentName: '',
    dependentRelationship: '',
    dependentEMRNo: '',
    createdBy: '',
    updatedBy: '',
};

export const INSURANCE_INITIAL_STATE: IInsuranceApiState = {
    data: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    providerData: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    planData: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    beneficiaryData: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    selectedInsurance: INSURANCE_INITIAL_DATA,
    selectedProvider: null,
    selectedPlan: null,
    selectedBeneficiary: null,
    serviceProviders: [],
    pageProps: {
        isDescending: false,
        pageNumber: 1,
        perPage: 10,
        searchText: '',
        sortingOn: '',
    },
    list: [],
    insuranceType: 'provider',
    loading: 'idle',
    error: null,
    benefitEligibility: null,
    providerDashboard: null,
    providerBeneficiaries: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    providerPlans: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
    providerBeneficiaryUsage: {
        list: [],
        totalPages: 0,
        totalRecords: 0,
    },
};
